__turbopack_context__.v({
  "button": "text-image-block-module-scss-module__z8e-qW__button",
  "button1": "text-image-block-module-scss-module__z8e-qW__button1",
  "buttonSimple": "text-image-block-module-scss-module__z8e-qW__buttonSimple",
  "buttonSimple1": "text-image-block-module-scss-module__z8e-qW__buttonSimple1",
  "buttongroup": "text-image-block-module-scss-module__z8e-qW__buttongroup",
  "container": "text-image-block-module-scss-module__z8e-qW__container",
  "iconWrapper": "text-image-block-module-scss-module__z8e-qW__iconWrapper",
  "imageIcon": "text-image-block-module-scss-module__z8e-qW__imageIcon",
  "imageIcon1": "text-image-block-module-scss-module__z8e-qW__imageIcon1",
  "li": "text-image-block-module-scss-module__z8e-qW__li",
  "list": "text-image-block-module-scss-module__z8e-qW__list",
  "subtitle": "text-image-block-module-scss-module__z8e-qW__subtitle",
  "text": "text-image-block-module-scss-module__z8e-qW__text",
  "text1": "text-image-block-module-scss-module__z8e-qW__text1",
  "textimageblock": "text-image-block-module-scss-module__z8e-qW__textimageblock",
  "title": "text-image-block-module-scss-module__z8e-qW__title",
});
